import { genericGetServerSideProps } from '@app/server/utils/getInitialData';
import type { NextAppContext } from '@app/server/utils/getInitialData/types';
import pageConfig from '@sell/pages/Sell/pageConfig';

export { default } from '@sell/pages/Sell/SellContainer';

export const getServerSideProps = async (ctx: NextAppContext) =>
  genericGetServerSideProps(ctx, pageConfig);
